"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggleableChange = void 0;
const react_1 = require("react");
const inputs_1 = require("../lib/inputs");
function useToggleableChange(onChangeHandle, onClickFromProps, disabled) {
    const lastClickSimulationRef = react_1.useRef(0);
    const simulateInputClick = react_1.useCallback((e) => {
        if (e.simulatedInput || disabled) {
            return;
        }
        const curTime = Date.now();
        // todo: better solution for managing mobile running
        //  both onClick and onTouchStart
        if (lastClickSimulationRef.current > (curTime - 300)) {
            return;
        }
        onClickFromProps === null || onClickFromProps === void 0 ? void 0 : onClickFromProps(e);
        lastClickSimulationRef.current = curTime;
        e.simulatedInput = true;
        const input = inputs_1.getInputElement(e);
        if (!input) {
            // eslint-disable-next-line no-console
            console.log(e);
            throw new Error('Cant find input from click event. If you added a custom element, be sure to add "pointer-events-none" to its class');
        }
        const changeEvent = new Event('change');
        Object.defineProperty(changeEvent, 'target', { writable: false, value: input });
        onChangeHandle === null || onChangeHandle === void 0 ? void 0 : onChangeHandle(changeEvent);
    }, [disabled, onChangeHandle, onClickFromProps]);
    return {
        onClick: simulateInputClick
    };
}
exports.useToggleableChange = useToggleableChange;
